module.exports = __webpack_public_path__ + "img/high-desert-laurel.156cb5d2.png";